import { render } from "./DetailsEducation.vue?vue&type=template&id=5768e25f&scoped=true"
import script from "./DetailsEducation.vue?vue&type=script&lang=js"
export * from "./DetailsEducation.vue?vue&type=script&lang=js"

import "./DetailsEducation.vue?vue&type=style&index=0&id=5768e25f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5768e25f"]])

export default __exports__